import { render, staticRenderFns } from "./errPage.vue?vue&type=template&id=7104f8d4"
import script from "./errPage.vue?vue&type=script&lang=ts"
export * from "./errPage.vue?vue&type=script&lang=ts"
import style0 from "./errPage.vue?vue&type=style&index=0&id=7104f8d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports